// mds-dojo — dojo/topic. Global pub/sub hub. subscribe returns a removable handle.

type Listener = (...args: any[]) => void;
const hub: Record<string, Listener[]> = {};

export function subscribe(topic: string, listener: Listener): { remove: () => void } {
  const list = hub[topic] || (hub[topic] = []);
  list.push(listener);
  return {
    remove() {
      const i = list.indexOf(listener);
      if (i !== -1) { list.splice(i, 1); }
    },
  };
}

export function publish(topic: string, ...args: any[]): void {
  const list = hub[topic];
  if (!list) { return; }
  // Copy so a listener that unsubscribes mid-dispatch doesn't skip a sibling.
  for (const listener of list.slice()) {
    listener.apply(null, args);
  }
}

const topic = { subscribe, publish };
// Real dojo exposed window.dojo.publish/subscribe; legacy inline code uses them.
if (typeof window !== 'undefined') {
  (window as any).dojo = Object.assign((window as any).dojo || {}, {
    publish: (t: string, args?: any) => {
      if (Array.isArray(args)) { topic.publish(t, ...args); }
      else if (args === undefined) { topic.publish(t); }
      else { topic.publish(t, args); }
    },
    subscribe: (t: string, cb: any) => topic.subscribe(t, cb),
  });
}

export default topic;
